<template>
  <div
    @click="$emit('onClick')"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    class="w-full flex flex-wrap items-end h-12 cursor-pointer"
  >
    <div class="w-full">
      <div
        :class="customCssButton"
        class="h-1 border-t border-black transition-all ease-in-out duration-300"
      >
      </div>
      <button
        class="flex justify-end items-center focus:outline-none text-sm uppercase font-sansBold transition-all ease-in-out duration-300"
        :class="customCssButton"
        :disabled="disabled"
        :type="type"
        :id="id"
      >
        <slot>
          CustomButton
        </slot>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomButtonThree',
  props: {
    id: String,
    type: {
      type: String,
      default: 'button'
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    customCssButton: function () {
      var toReturn = ''
      if (this.dark) toReturn += ' text-black '
      else toReturn += ' text-white  '

      if (this.dark) toReturn += ' border-black'
      else toReturn += ' border-white '

      if (!this.disabled) {
        if (!this.hovered) {
          toReturn += ' w-full '
        } else {
          toReturn += ' w-5/6 '
        }
      }

      return toReturn
    }
  }
}
</script>
